/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {EntitlementConflictRequest} from '../models/EntitlementConflictRequest';
import type {EntitlementConflictResponse} from '../models/EntitlementConflictResponse';
import type {Error} from '../models/Error';
import type {RelationPage} from '../models/RelationPage';
import type {SortDirection} from '../models/SortDirection';

export interface GetProductUserEntitlementRelations$Request {
    userId: number;
    pageNumber: number;
    pageSize: number;
    sortDirection: SortDirection;
    requestBody?: Array<string>;
}

export interface GetProductUserEntitlementRelations$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getProductUserEntitlementRelationsRequest = createAction<PayloadData<void, GetProductUserEntitlementRelations$Request>>('PRODUCT_USER_ENTITLEMENTS__GET_PRODUCT_USER_ENTITLEMENT_RELATIONS__REQUEST');
export const getProductUserEntitlementRelationsSuccess = createAction<PayloadData<RelationPage, GetProductUserEntitlementRelations$Request>>('PRODUCT_USER_ENTITLEMENTS__GET_PRODUCT_USER_ENTITLEMENT_RELATIONS__SUCCESS');
export const getProductUserEntitlementRelationsFailure = createAction<PayloadData<Error, GetProductUserEntitlementRelations$Request, true>>('PRODUCT_USER_ENTITLEMENTS__GET_PRODUCT_USER_ENTITLEMENT_RELATIONS__FAILURE');

export const getProductUserEntitlementRelationsActions = [
    getProductUserEntitlementRelationsRequest,
    getProductUserEntitlementRelationsSuccess,
    getProductUserEntitlementRelationsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {number} meta.pageNumber
 * @param {number} meta.pageSize
 * @param {SortDirection} meta.sortDirection
 * @param {Array<string>} [meta.requestBody]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getProductUserEntitlementRelations = (meta: GetProductUserEntitlementRelations$Request, config?: GetProductUserEntitlementRelations$Config) => {
    const TRANSPORT_GET_PARAMS = {
        pageNumber: meta.pageNumber,
        pageSize: meta.pageSize,
        sortDirection: meta.sortDirection,
    };
    return {
        CALL_API: {
            types: getProductUserEntitlementRelationsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/product/user/${meta.userId}/entitlements`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface ProductUserEntitlementConflictChecker$Request {
    userId: number;
    entitlementConflictRequest?: EntitlementConflictRequest;
}

export interface ProductUserEntitlementConflictChecker$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const productUserEntitlementConflictCheckerRequest = createAction<PayloadData<void, ProductUserEntitlementConflictChecker$Request>>('PRODUCT_USER_ENTITLEMENTS__PRODUCT_USER_ENTITLEMENT_CONFLICT_CHECKER__REQUEST');
export const productUserEntitlementConflictCheckerSuccess = createAction<PayloadData<Array<EntitlementConflictResponse>, ProductUserEntitlementConflictChecker$Request>>('PRODUCT_USER_ENTITLEMENTS__PRODUCT_USER_ENTITLEMENT_CONFLICT_CHECKER__SUCCESS');
export const productUserEntitlementConflictCheckerFailure = createAction<PayloadData<Error, ProductUserEntitlementConflictChecker$Request, true>>('PRODUCT_USER_ENTITLEMENTS__PRODUCT_USER_ENTITLEMENT_CONFLICT_CHECKER__FAILURE');

export const productUserEntitlementConflictCheckerActions = [
    productUserEntitlementConflictCheckerRequest,
    productUserEntitlementConflictCheckerSuccess,
    productUserEntitlementConflictCheckerFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {EntitlementConflictRequest} [meta.entitlementConflictRequest]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const productUserEntitlementConflictChecker = (meta: ProductUserEntitlementConflictChecker$Request, config?: ProductUserEntitlementConflictChecker$Config) => {
    return {
        CALL_API: {
            types: productUserEntitlementConflictCheckerActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/product/user/${meta.userId}/entitlements-conflicts`,
            TRANSPORT_REQUEST_BODY: meta.entitlementConflictRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

